import React, { useCallback, useEffect, useRef } from 'react';
import OfferTable from '../EvaluationOperational/Components/OfferTable';

const offersEqual = (a = [], b = []) =>
  a.length === b.length &&
  a.every(
    (entry, index) =>
      entry?.rowKey === b[index]?.rowKey &&
      entry?.selectionKey === b[index]?.selectionKey &&
      entry?.idOffer === b[index]?.idOffer &&
      entry?.kind === b[index]?.kind &&
      entry?.quantityIncotermId === b[index]?.quantityIncotermId &&
      entry?.quantityIncotermCounterId === b[index]?.quantityIncotermCounterId
  );

/**
 * Stable onSelectedOffersChange wrapper — avoids OfferTable effect loops when
 * parent recreates handlers each render.
 */
const NegotiationOfferTable = ({
  parcelId,
  requirementIndex,
  onOffersChange,
  procurementId,
  procurement,
  parcels,
  isLoadingParcels = false,
  selectionClearToken = 0,
  isActive = true,
  onNegotiationOfferAvailability,
  preselectedOffers = null,
}) => {
  const onOffersChangeRef = useRef(onOffersChange);
  onOffersChangeRef.current = onOffersChange;
  const lastOffersRef = useRef(null);

  const handleSelectedOffersChange = useCallback(
    offers => {
      const nextOffers = Array.isArray(offers) ? offers : [];
      if (
        lastOffersRef.current &&
        offersEqual(lastOffersRef.current, nextOffers)
      ) {
        return;
      }
      lastOffersRef.current = nextOffers;
      onOffersChangeRef.current?.(parcelId, requirementIndex, nextOffers);
    },
    [parcelId, requirementIndex]
  );

  useEffect(() => {
    lastOffersRef.current = null;
  }, [parcelId, requirementIndex, selectionClearToken]);

  return (
    <OfferTable
      viewMode='negotiation'
      procurementId={procurementId}
      procurement={procurement}
      parcels={parcels}
      isLoadingParcels={isLoadingParcels}
      onSelectedOffersChange={handleSelectedOffersChange}
      selectionClearToken={selectionClearToken}
      focusParcelId={parcelId}
      focusRequirementIndex={requirementIndex}
      isActive={isActive}
      onNegotiationOfferAvailability={onNegotiationOfferAvailability}
      preselectedOffers={preselectedOffers}
    />
  );
};

export default NegotiationOfferTable;
